export default __webpack_public_path__ + "a221de18854f9503d23723a8ed228417.png";